/*
|--------------------------------------------------------------------------
| Views: Article Half Card
|--------------------------------------------------------------------------
*/

/**
 * Infinite Scroll
 * @namespace
 */
__gh__webApp.views.articleHalfCard = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		__gh__webApp.utilities.infiniteScroll.init();

	},

	"prepItemData": function(items){
		var commonViewJS		= __gh__webApp.views.common;
			items 				= commonViewJS.prepItemData(items);
			return items;
	},
	"hookBeforeBucketHasItems": function(bucket){
		//Check local storage for feed url
		//bucket.view
		var localStorage					= __gh__webApp.localStorage,
			feedURL							= bucket.feedURL,
			infiniteScrollFeedURL			= bucket.view.infiniteScroll.url,
			localStorageFeedURL 			= localStorage.getItem("localStorageFeedURL");
			bucket.feedURL 					= (localStorageFeedURL) ? localStorageFeedURL : feedURL;
			bucket.view.infiniteScroll.url 	= (localStorageFeedURL) ? localStorageFeedURL : infiniteScrollFeedURL;
			localStorage.removeItem("localStorageFeedURL");

		return bucket;
	},
	"getSubView": function(bucket){
		// Prep Items
		bucket.items.main				= this.prepItemData(bucket.items.main);
		bucket.view.hitPaywall			= (typeof hitPaywall !== 'undefined') ? hitPaywall : false;
		bucket.view.name 				= "buckets/articleHalfCard/default";
		bucket.view.infiniteScroll.view	= "buckets/articleHalfCard/partials/_default";
		return bucket;

	}
};
